document.addEventListener('afterBlitzInject', function () {
  let detailLink = document.getElementById('elc-detail-link');
  if (detailLink) {
    detailLink.addEventListener("click", toggleExpand);
  }

  let hideDetailLink = document.getElementById("elc-hide-detail-link");
  if (hideDetailLink) {
    hideDetailLink.addEventListener("click", toggleExpand);
  }

  let saveLink = document.getElementById("elc-save-link");
  if (saveLink) {
    saveLink.addEventListener("click", submitConsent);
  }

  let acceptLink = document.getElementById("elc-accept-link");
  if (acceptLink) {
    acceptLink.addEventListener("click", submitConsent);
  }

  let acceptAllLink = document.getElementById("elc-accept-all-link");
  if (acceptAllLink) {
    acceptAllLink.addEventListener("click", submitAllConsent);
  }

  let declineAllLink = document.getElementById("elc-decline-all-link");
  if (declineAllLink) {
    declineAllLink.addEventListener("click", submitDeclineAllConsent);
  }

  let tabLink = document.getElementById("elc-tab-link");
  if (tabLink) {
    tabLink.addEventListener("click", toggleTab);
  }

  addWindowObject();
});

function submitConsent(event: Event) {
  event.preventDefault();

  let form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    submitData(form, false);
  }
}

function submitAllConsent(event: Event) {
  event.preventDefault();

  let form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    for (let i = 0; i < form.elements.length; i++) {
      const element = form.elements[i] as HTMLInputElement;
      if (element.type === 'checkbox' && !element.checked) {
        element.checked = true;
      }
    }
    submitData(form, true);
  }
}

function submitDeclineAllConsent(event: Event) {
  event.preventDefault();

  let form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form) {
    for (let i = 0; i < form.elements.length; i++) {
      const element = form.elements[i] as HTMLInputElement;
      if (element.type === 'checkbox' && element.checked) {
        element.checked = false;
      }
    }
    submitData(form, false);
  }
}

function submitData(form: HTMLFormElement, submitAll: boolean) {
  let data = serialize(form);
  document.getElementById("elc-cookie-consent")?.classList.toggle('elc-hidden');
  document.getElementById("elc-cookie-consent-container")?.classList.toggle('elc-hidden');
  let cookieTab = document.getElementById("elc-cookie-tab");
  cookieTab?.classList.toggle('elc-hidden');

  let xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url || '');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  if (submitAll) {
    data += '&acceptAll=true';
  }
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      addWindowObject();
      if (xhr.status !== 200) {
        console.log('Error: ' + xhr.status);
      } else if (form.dataset.refresh === "true" && form.dataset.refreshtime) {
        refresh(parseInt(form.dataset.refreshtime));
      }
    }
  };
}

function refresh(ms: number) {
  setTimeout(function() {
    location.reload();
  }, ms);
}

function toggleExpand(event: Event) {
  event.preventDefault();
  document.getElementById("elc-cookie-consent")?.classList.toggle('elc-fullwidth');
  document.getElementById("elc-cookie-consent")?.classList.toggle('elc-small');
}

function toggleTab(event: Event) {
  event.preventDefault();
  document.getElementById("elc-cookie-consent")?.classList.toggle('elc-hidden');
  document.getElementById("elc-cookie-consent-container")?.classList.toggle('elc-hidden');
  document.getElementById("elc-cookie-tab")?.classList.toggle('elc-hidden');

  const consentElement = document.getElementById("elc-cookie-consent");
  consentElement?.classList.add('elc-fullwidth');
  consentElement?.classList.remove('elc-small');
}

function addWindowObject() {
  let form = document.querySelector<HTMLFormElement>('#elc-cookie-consent-form');
  if (form && form.dataset.show) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', form.dataset.show);
    xhr.send();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status !== 200) {
          console.log('Error: ' + xhr.status);
          window.ccc = {};
        } else {
          if (xhr.response === 'null') {
            window.ccc = {};
          } else {
            window.ccc = JSON.parse(xhr.response);
            runTracking();
            // Ensure initGA4Events is defined elsewhere in your codebase
            if (typeof initGA4Events === 'function') {
              initGA4Events();
            }
          }
        }
      }
    };
  }
}

// Ensure initGA4Events is defined or provide a fallback
function initGA4Events() {
  console.warn('initGA4Events is not implemented.');
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
let serialize = function (form: HTMLFormElement): string {
  let serialized: string[] = [];

  for (let i = 0; i < form.elements.length; i++) {
    let field = form.elements[i] as HTMLInputElement | HTMLSelectElement;

    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'button') continue;

    if (field instanceof HTMLSelectElement && field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (field.options[n].selected) {
          serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
        }
      }
    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');
};

export {};